export const productionConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    fantasyGameEngine: `${process.env.VUE_APP_FANTASY_GAME_ENGINE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlobUrl: 'https://sportshub.blob.core.windows.net',
    tpfHost: 'http://play.sports-hub.co.za/',
    nodeEnv: `Prod`
}

export const developmentConfig = {
    dcbService: `${process.env.VUE_APP_STAGING_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    fantasyGameEngine: `${process.env.VUE_APP_FANTASY_GAME_ENGINE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlobUrl: 'https://sportshub-dev.blob.core.windows.net',
    tpfHost: 'http://staging-play.sports-hub.co.za/',
    nodeEnv: `Dev`
}

export const stagingConfig = {
    dcbService: `${process.env.VUE_APP_STAGING_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    fantasyGameEngine: `${process.env.VUE_APP_FANTASY_GAME_ENGINE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlobUrl: 'https://sportshub-dev.blob.core.windows.net',
    tpfHost: 'http://staging-play.sports-hub.co.za/',
    nodeEnv: `Prod`
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}

export default environmentConfig
